import { useState } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
  Box
} from '@mui/material'
import { useSelector } from 'react-redux'
import { WaterTestStripSelector } from '../../../../../store/waterTestStrip'
import { ParameterResult } from '../ParameterResult'
import SearchOffIcon from '@mui/icons-material/SearchOff'

export const ResultsAccordion = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const waterTestStripResult = useSelector(WaterTestStripSelector.selectWaterTestStripResult)
  const [expandedPanel, setExpandedPanel] = useState<number>(0)



  if (!waterTestStripResult || Object.keys(waterTestStripResult).length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
          backgroundColor: 'white',
          borderRadius: '16px',
          border: '1px solid #E2E8F0'
        }}
      >
        <SearchOffIcon sx={{ fontSize: 48, color: 'grey.400', mb: 2 }} />
        <Typography color="grey.600" variant="body1">
          No test results available
        </Typography>
      </Box>
    )
  }

  const handleChange = (panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpandedPanel(isExpanded ? panel : -1)
  }

  return (
    <Stack spacing={2}>
      {Object.entries(waterTestStripResult).map(([category, parameters], index) => (
        <Accordion
          key={index}
          expanded={expandedPanel === index}
          onChange={handleChange(index)}
          sx={{
            backgroundColor: 'white',
            boxShadow: 'none',
            border: '1px solid #E2E8F0',
            borderRadius: '16px !important',
            '&:before': {
              display: 'none',
            },
            '& .MuiButtonBase-root': {
              height: isMobile ? 'auto' : '65px',
              padding: isMobile ? '0 16px' : '0px 24px',
            },
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Stack direction={{xs: "column", md:"row"}} alignItems={{xs: "flex-start", md:"center"}} gap={{ md:2, xs:0.5}}>
                <Typography fontSize={'1rem'} fontWeight="bold" color="primary.dark">
                  {category}
                </Typography>
                <Chip
                  label={`${parameters.length} elements`}
                  sx={{
                    backgroundColor: theme.palette.background.default,
                    color: theme.palette.grey[600],
                    fontWeight: 'medium',
                    fontSize: '0.875rem',
                  }}
                />
              </Stack>
          </AccordionSummary>
          <AccordionDetails sx={{ px: isMobile ? '16px' : '24px' }}>
            <Stack spacing={2}>
              {parameters.map((param, idx) => (
                <ParameterResult key={`${param.name}-${idx}`} parameter={param} />
              ))}
            </Stack>
          </AccordionDetails>
        </Accordion>
      ))}
    </Stack>
  )
}
